import { createStore } from "vuex";
import VueCookies from "vue-cookies";

export default createStore({
  state: {
    isLogin: VueCookies.get("tokenWeb") ? true : false, //用户是否登录
  },
  mutations: {
    //设置登录状态
    setLoginStatus(state, payload) {
      state.isLogin = payload.status;
    },
  },
  actions: {},
  modules: {},
});
